const twoDigit = /^[0-9]+([.]{1}[0-9]{1,2})?$/
export default {
  gameGroupId: [
    {
      required: true,
      message: '请选择游戏组',
      trigger: 'change'
    }
  ],
  platform: [
    {
      required: true,
      message: '请选择平台',
      trigger: 'change'
    }
  ],
  mediaId: [
    {
      required: true,
      message: '请选择媒体',
      trigger: 'change'
    }
  ],
  ruleInfo: [{ required: true }, { validator: validateRules }]
}

export function validateRules(rule, value, callback) {
  const { key, operator, value: v } = value
  if (!key) return callback(new Error('请选择规则值'))
  if (!operator) return callback(new Error('请选择操作符'))
  if (!v || !v.trim()) return callback(new Error('请输入值'))
  if (!twoDigit.test(v)) {
    return callback(new Error('请输入数值，最多保留2位小数'))
  }

  callback()
}
